import layout from '@/layout'
// import { _l } from '@/i18n'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/order',
  component: layout,
  meta: {
    funcID: 'F0001',
    PID: 'F00',
  },
  children: ((pre) => [
    {
      path: 'customerOrder',
      name: `${pre}customerOrder`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F000101',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/customerorder'),
    },
    {
      path: 'customerOrder/:pageType/:code?',
      name: `${pre}customerOrderDetail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { orderNo = '' } = $route.query || {}
          return orderNo || '客户订单'
        },
        funcID: 'F000101',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/customerorder/detail'),
    },
    {
      path: 'orderReview',
      name: `${pre}orderReview`,
      meta: {
        ...meta,
        head: { back: false },
        title: '接单评审管理',
        funcID: 'F000102',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/orderreview'),
    },
    {
      path: 'orderReview/:pageType/:code?',
      name: `${pre}orderReview-detail`,
      meta: {
        ...meta,
        head: { back: true },
        title: '接单评审管理详情',
        funcID: 'F000102',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/orderreview/detail'),
    },
    {
      path: 'changeOrder',
      name: `${pre}changeOrder`,
      meta: {
        ...meta,
        head: { back: false },
        title: '订单变更申请',
        funcID: 'F000103',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/changeorder'),
    },
    {
      path: 'changeOrder/:pageType/:code?',
      name: `${pre}changeOrderDetail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { changeOrderNo = '' } = $route.query || {}
          return changeOrderNo || '订单变更申请'
        },
        funcID: 'F000103',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/changeorder/detail'),
    },
    {
      path: 'changeRequest',
      name: `${pre}changeRequest`,
      meta: {
        ...meta,
        head: { back: false },
        title: '客户订单变更',
        funcID: 'F000104',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/changerequest'),
    },
    {
      path: 'changeOrderConfirm',
      name: `${pre}changeConfirm`,
      meta: {
        ...meta,
        head: { back: false },
        title: '生产订单变更审批',
        funcID: 'F000105',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/changeconfirm'),
    },
    {
      path: 'changeOrderConfirm/:pageType/:code?',
      name: `${pre}changeOrderConfirmDetail`,
      meta: {
        ...meta,
        head: { back: true },
        title: '生产订单变更审批详情',
        funcID: 'F000105',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/changeconfirm/detail'),
    },
    {
      path: 'dashboard',
      name: `${pre}dashboard`,
      meta: {
        ...meta,
        head: { back: false },
        title: '订单跟踪看板',
        funcID: 'F000106',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/dashboard'),
    },
    {
      path: 'dashboard/:pageType/:code?',
      name: `${pre}dashboard-detail`,
      meta: {
        ...meta,
        head: { back: false },
        title: '订单跟踪看板详情',
        funcID: 'F000106',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/dashboard/detail'),
    },
    {
      path: 'reportOrderList',
      name: `${pre}reportOrderList`,
      meta: {
        ...meta,
        head: { back: false },
        title: '订单明细查询报表',
        funcID: 'F000107',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/reportorderlist'),
    },
    {
      path: 'expense',
      name: `${pre}expense`,
      meta: {
        ...meta,
        head: { back: false },
        title: '订单费用填报',
        funcID: 'F000108',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/expense'),
    },
    {
      path: 'expense/:pageType/:code?',
      name: `${pre}expense-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { orderExpenseNo = '' } = $route.query || {}
          return orderExpenseNo || '订单费用'
        },
        funcID: 'F000108',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/expense/detail'),
    },
    {
      path: 'budget',
      name: `${pre}budget`,
      meta: {
        ...meta,
        head: { back: false },
        title: '部门年度预算',
        funcID: 'F000109',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/budget'),
    },
    {
      path: 'budget/:pageType/:code?',
      name: `${pre}budget-detail`,
      meta: {
        ...meta,
        head: { back: false },
        title: ({ $route }) => {
          const { reportBudgetNo = '' } = $route.query || {}
          if (reportBudgetNo) {
            return `部门年度预算 | ${reportBudgetNo}`
          }
          return '部门年度预算'
        },
        funcID: 'F000109',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/budget/detail'),
    },
    {
      path: 'budgetAnalysis',
      name: `${pre}budgetAnalysis`,
      meta: {
        ...meta,
        head: { back: false },
        title: '预算执行看板',
        funcID: 'F000110',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/budgetanalysis'),
    },
    {
      path: 'changeSales',
      name: `${pre}changeSales`,
      meta: {
        ...meta,
        head: { back: false },
        title: '订单人员变更',
        funcID: 'F000111',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/changeSales'),
    },
    {
      path: 'cancelRequest',
      name: `${pre}cancelRequest`,
      meta: {
        ...meta,
        head: { back: false },
        title: '订单取消申请',
        funcID: 'F000112',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/cancelRequest'),
    },
    {
      path: 'cancelRequest/:pageType/:code?',
      name: `${pre}cancelRequest-detail`,
      meta: {
        ...meta,
        head: { back: false },
        title: '订单取消申请详情',
        funcID: 'F000112',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/cancelRequest/detail'),
    },
    {
      path: 'cancelComfirm',
      name: `${pre}cancelComfirm`,
      meta: {
        ...meta,
        head: { back: false },
        title: '订单取消审核',
        funcID: 'F000113',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/cancelComfirm'),
    },
    {
      path: 'shipmentPlan',
      name: `${pre}shipmentPlan`,
      meta: {
        ...meta,
        head: { back: false },
        title: '订单出货计划',
        funcID: 'F000114',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/shipmentPlan'),
    },
    {
      path: 'shipmentPlanConfirm',
      name: `${pre}shipmentPlanConfirm`,
      meta: {
        ...meta,
        head: { back: false },
        title: '订单出货计划确认',
        funcID: 'F000115',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/shipmentPlanConfirm'),
    },
    {
      path: 'shipmentPlanConfirm/:pageType/:code?',
      name: `${pre}shipmentPlanConfirm-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { shipmentNo = '' } = $route.query || {}
          return shipmentNo || '订单出货计划确认详情'
        },
        funcID: 'F000115',
        PID: 'F00',
      },
      component: () =>
        import('@/views/factory/order/shipmentPlanConfirm/detail'),
    },
    {
      path: 'deduction',
      name: `${pre}deduction`,
      meta: {
        ...meta,
        head: { back: false },
        title: '订单扣款填报',
        funcID: 'F000116',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/deduction'),
    },
    {
      path: 'deduction/:pageType/:code?',
      name: `${pre}deduction-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { orderDeductionNo = '' } = $route.query || {}
          return orderDeductionNo || '订单扣款'
        },
        funcID: 'F000116',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/deduction/detail'),
    },
    {
      path: 'notbatchgoods',
      name: `${pre}notbatchgoods`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'F000117',
        PID: 'F00',
      },
      component: () => import('@/views/factory/order/notbatchgoods'),
    },
  ])('order-'),
}
